import React, { useState, useCallback, useEffect } from 'react';
import { useQueryClient } from 'react-query';

import { searchAll } from 'src/api-services';

import {
  ResultsContainer,
  ResultGroupTitle,
  SearchHitLink,
  NoResultsTitle,
} from './SearchResults.styles';

const initialResults = {
  somethings: [],
  anythings: [],
  tags: [],
};

function SearchResults({ term }) {
  const [results, setResults] = useState(initialResults);
  const queryClient = useQueryClient();

  const submitSearch = useCallback(
    async (term) => {
      const { data = {} } = await queryClient.fetchQuery(['search', term], () =>
        searchAll(term)
      );
      setResults(data);
    },
    [queryClient]
  );

  useEffect(() => {
    if (term.length > 2) {
      submitSearch(term);
    }
  }, [submitSearch, term]);

  const hasSomethings = results.somethings.length > 0;
  const hasAnythings = results.anythings.length > 0;
  const hasTags = results.tags.length > 0;

  const hasAtLeastOne = hasSomethings || hasAnythings || hasTags;

  return (
    <ResultsContainer>
      {!hasAtLeastOne && <NoResultsTitle>Nothing 😔</NoResultsTitle>}

      {hasSomethings && (
        <>
          <ResultGroupTitle>Somethings</ResultGroupTitle>
          {results.somethings.map((something) => (
            <SearchHitLink
              key={`something-${something.id}`}
              to={`/somethings/${something.id}`}
            >
              {something.title}
            </SearchHitLink>
          ))}
        </>
      )}

      {hasAnythings && (
        <>
          <ResultGroupTitle>Anythings</ResultGroupTitle>
          {results.anythings.map((anything) => (
            <SearchHitLink
              key={`anything-${anything.id}`}
              to={`/anythings/${anything.id}`}
            >
              {anything.type}:{anything.value1.substring(0, 30)}
              ...
              {anything.value2.substring(0, 30)}
              ...
            </SearchHitLink>
          ))}
        </>
      )}

      {hasTags && (
        <>
          <ResultGroupTitle>Tags</ResultGroupTitle>
          {results.tags.map((tag) => (
            <SearchHitLink key={`tag-${tag.id}`} to={`/tags/${tag.id}`}>
              {tag.title}
            </SearchHitLink>
          ))}
        </>
      )}
    </ResultsContainer>
  );
}

export default SearchResults;
